import { normalize } from "@app/helpers";
import styled from "@2pulse/responsive";

const Section = styled.View(() => ({
  backgroundColor: 'rgba(240, 249, 252, 0.03)',
  borderRadius: normalize(12),
  padding: normalize(20),
  marginBottom: normalize(20),
}));

const SectionTitle = styled.Text(({ theme }) => ({
  color: theme.colors.babypowder,
  fontFamily: 'Work Sans',
  fontSize: normalize(18),
  fontWeight: '600',
  marginBottom: normalize(25),
  textTransform: 'uppercase',
  letterSpacing: 1,
  borderColor: "red",
  borderBottomWidth: 3,
  borderBottomColor: theme.colors.gold,
  paddingBottom: 4,
  alignSelf: 'flex-start',
}));

const SectionContent = styled.View({
  gap: normalize(15),
});

export const FormSection = {
  Section,
  Title: SectionTitle,
  Content: SectionContent
}